<template>
    <div>
        <a class="logo" href="https://www.compnow.com.au" target="_blank" title="Compnow"
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Layer_1"
                x="0px"
                y="0px"
                viewBox="0 0 91 56"
                style="enable-background: new 0 0 91 56;"
                xml:space="preserve"
                class="svg replaced-svg"
            >
                <g>
                    <defs>
                        <rect id="SVGID_3_" width="91" height="56"></rect>
                    </defs>
                    <clipPath id="SVGID_1_">
                        <use xlink:href="#SVGID_3_" style="overflow: visible;"></use>
                    </clipPath>
                    <path
                        class="st0"
                        :class="theme"
                        d="M31.2,16.3c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5S34.8,16.3,31.2,16.3z M31.2,0   c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8S36.6,0,31.2,0z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M0,9.8C0,4.4,4.4,0,9.8,0c4.4,0,8.1,2.8,9.3,6.9c-1.3,0-2.8,0-3.5,0c-1.1-2.2-3.3-3.6-5.8-3.6   c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5c2.1,0,4-1.1,5.2-2.7c0.6,0,2.3,0,3.8,0c-1.5,3.6-5,6-9,6C4.4,19.5,0,15.1,0,9.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M80.8,16.3c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5S84.4,16.3,80.8,16.3z M80.8,0   C75.4,0,71,4.4,71,9.8v13.5h3.2v-6l1.7,1c1.5,0.9,3.2,1.3,4.9,1.3c5.4,0,9.8-4.4,9.8-9.8C90.6,4.4,86.2,0,80.8,0z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M61,0c-2.1,0-4,1-5.3,2.5C54.5,1,52.6,0,50.4,0c-3.8,0-6.9,3.1-6.9,6.9v12.2h3.2V6.9c0-2,1.7-3.7,3.7-3.7   c2,0,3.7,1.7,3.7,3.7v12.2h3.2V6.9c0-2,1.7-3.7,3.7-3.7c2,0,3.7,1.7,3.7,3.7v12.2h3.2V6.9C68,3.1,64.9,0,61,0z"
                    ></path>
                    <path
                        class="st1"
                        :class="theme"
                        d="M10.5,22.1C10.5,22.1,10.4,22.1,10.5,22.1c-0.3,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0   C4.1,22.4,0,26.6,0,31.8c0,0,0,7.6,0,9.4c1,0,2.2,0,3.3,0c0-1.8,0-9.4,0-9.4c0-2.6,1.5-4.8,3.7-5.9c0.7-0.3,1.5-0.6,2.3-0.6   c0.1,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.8,0.1,1.6,0.3,2.3,0.6c2.2,1.1,3.7,3.3,3.7,5.9c0,0,0,7.6,0,9.4c1.1,0,2.2,0,3.3,0   c0-1.8,0-9.4,0-9.4C19.6,26.6,15.6,22.4,10.5,22.1z"
                    ></path>
                    <path
                        class="st1"
                        :class="theme"
                        d="M31.2,38.3c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5C37.8,35.4,34.8,38.3,31.2,38.3z M31.2,22   c-5.4,0-9.8,4.4-9.8,9.8c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8C41,26.4,36.6,22,31.2,22z"
                    ></path>
                    <path
                        class="st1"
                        :class="theme"
                        d="M64.8,22v12.2c0,2-1.7,3.7-3.7,3.7c-2,0-3.7-1.7-3.7-3.7V22h-3.2v12.2c0,2-1.7,3.7-3.7,3.7   c-2,0-3.7-1.7-3.7-3.7V22h-3.2v12.2c0,3.8,3.1,6.9,6.9,6.9c2.1,0,4-1,5.3-2.5c1.3,1.5,3.2,2.5,5.3,2.5c3.8,0,6.9-3.1,6.9-6.9V22   H64.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M3.9,49.4c-0.3-0.3-0.7-0.5-1-0.5c-1,0-1.6,0.8-1.6,1.6c0,0.8,0.6,1.6,1.6,1.6c0.4,0,0.8-0.2,1-0.5l0.9,1   c-0.5,0.5-1.5,0.7-1.9,0.7c-1.6,0-2.9-1.1-2.9-2.8s1.3-2.8,2.9-2.8c0.7,0,1.4,0.2,1.9,0.8L3.9,49.4z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M8.3,52.1c1,0,1.6-0.8,1.6-1.6c0-0.8-0.6-1.6-1.6-1.6c-1,0-1.6,0.8-1.6,1.6C6.7,51.3,7.3,52.1,8.3,52.1z    M8.3,47.7c1.6,0,2.9,1.1,2.9,2.8c0,1.7-1.3,2.8-2.9,2.8s-2.9-1.1-2.9-2.8C5.4,48.8,6.7,47.7,8.3,47.7z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M12.4,47.8h1.3v0.8h0c0.2-0.5,0.7-1,1.6-1c0.8,0,1.4,0.3,1.7,1c0.4-0.7,1-1,1.8-1c1.4,0,1.9,1,1.9,2.3v3.2   h-1.3v-3c0-0.7-0.2-1.3-1-1.3c-0.8,0-1.2,0.7-1.2,1.4v2.9h-1.3V50c0-0.7-0.3-1.1-0.9-1.1c-0.9,0-1.2,0.6-1.2,1.4v2.9h-1.3   L12.4,47.8L12.4,47.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M25.1,48.9c-1,0-1.6,0.8-1.6,1.6c0,0.8,0.6,1.6,1.6,1.6c1,0,1.6-0.8,1.6-1.6C26.7,49.6,26.1,48.9,25.1,48.9z    M22.2,47.8h1.3v0.8h0c0.4-0.6,1.1-0.9,1.8-0.9c1.7,0,2.7,1.2,2.7,2.8c0,1.6-1.1,2.8-2.6,2.8c-1,0-1.5-0.5-1.8-0.8h0v3.2h-1.3   L22.2,47.8L22.2,47.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M29.3,47.8h1.3v0.9h0c0.2-0.5,0.7-1,1.6-1c1.4,0,2,1,2,2.1v3.4h-1.3v-2.7c0-0.6,0-1.6-1-1.6   c-0.9,0-1.2,0.6-1.2,1.4v2.9h-1.3L29.3,47.8L29.3,47.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M38.4,52.1c1,0,1.6-0.8,1.6-1.6c0-0.8-0.6-1.6-1.6-1.6c-1,0-1.6,0.8-1.6,1.6C36.8,51.3,37.4,52.1,38.4,52.1z    M38.4,47.7c1.6,0,2.9,1.1,2.9,2.8c0,1.7-1.3,2.8-2.9,2.8c-1.6,0-2.9-1.1-2.9-2.8C35.5,48.8,36.8,47.7,38.4,47.7z"
                    ></path>
                    <polygon
                        class="st0"
                        :class="theme"
                        points="41.8,47.8 43.3,47.8 44.4,51.5 44.5,51.5 45.6,47.8 47,47.8 48.2,51.5 48.2,51.5 49.3,47.8 50.7,47.8    48.8,53.2 47.5,53.2 46.2,49.5 46.2,49.5 45.1,53.2 43.7,53.2  "
                    ></polygon>
                    <path
                        class="st0"
                        :class="theme"
                        d="M51.5,51.5c0.5,0,0.9,0.4,0.9,0.8c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.8C50.6,51.9,51,51.5,51.5,51.5z   "
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M57.6,49.4c-0.3-0.3-0.7-0.5-1-0.5c-1,0-1.6,0.8-1.6,1.6c0,0.8,0.6,1.6,1.6,1.6c0.4,0,0.8-0.2,1-0.5l0.9,1   c-0.5,0.5-1.5,0.7-1.9,0.7c-1.6,0-2.9-1.1-2.9-2.8s1.3-2.8,2.9-2.8c0.7,0,1.4,0.2,1.9,0.8L57.6,49.4z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M62,52.1c1,0,1.6-0.8,1.6-1.6c0-0.8-0.6-1.6-1.6-1.6s-1.6,0.8-1.6,1.6S61,52.1,62,52.1z M62,47.7   c1.6,0,2.9,1.1,2.9,2.8c0,1.7-1.3,2.8-2.9,2.8c-1.6,0-2.9-1.1-2.9-2.8C59.1,48.8,60.4,47.7,62,47.7z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M66.1,47.8h1.3v0.8h0c0.2-0.5,0.7-1,1.6-1c0.8,0,1.4,0.3,1.7,1c0.4-0.7,1-1,1.8-1c1.4,0,1.9,1,1.9,2.3v3.2   h-1.3v-3c0-0.7-0.2-1.3-1-1.3c-0.8,0-1.2,0.7-1.2,1.4v2.9h-1.3V50c0-0.7-0.3-1.1-0.9-1.1c-0.9,0-1.2,0.6-1.2,1.4v2.9h-1.3   L66.1,47.8L66.1,47.8z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M76.8,51.5c0.5,0,0.9,0.4,0.9,0.8c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.8   C75.9,51.9,76.3,51.5,76.8,51.5z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M82.5,50.8h-0.3c-0.7,0-2,0.1-2,0.8c0,0.5,0.5,0.7,0.9,0.7c0.9,0,1.4-0.5,1.4-1.2V50.8z M82.6,52.4L82.6,52.4   c-0.4,0.6-1,0.9-1.8,0.9c-1,0-2-0.5-2-1.6c0-1.7,2-1.9,3.4-1.9h0.3v-0.1c0-0.7-0.5-1-1.2-1c-0.6,0-1.1,0.2-1.4,0.6l-0.7-0.7   c0.6-0.6,1.4-0.9,2.3-0.9c2.3,0,2.3,1.7,2.3,2.4v3.1h-1.2V52.4z"
                    ></path>
                    <path
                        class="st0"
                        :class="theme"
                        d="M90.2,53.2h-1.3v-0.9h0c-0.2,0.5-0.7,1-1.6,1c-1.4,0-2-1-2-2.1v-3.4h1.3v2.7c0,0.6,0,1.6,1,1.6   c0.9,0,1.2-0.6,1.2-1.4v-2.9h1.3V53.2z"
                    ></path>
                </g></svg
        ></a>
    </div>
</template>

<script>
export default {
    name: 'compnow-logo',
    props: {
        theme: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['default', 'dark', 'white', 'black'].includes(value)
            }
        }
    }
}
</script>

<style scoped>
.st0 {
    clip-path: url(#SVGID_1_);
}
.st1 {
    clip-path: url(#SVGID_1_);
}
.st0.default {
    fill: #616d70;
}
.st1.default {
    fill: #abc03f;
}
.st0.dark {
    fill: #ffffff;
}
.st1.dark {
    fill: #abc03f;
}
.st0.white {
    fill: #ffffff;
}
.st1.white {
    fill: #ffffff;
}
.st0.black {
    fill: #000000;
}
.st1.black {
    fill: #000000;
}
</style>
